import React, {useState} from 'react';

// this page is only for test receiving data

const API_KEY = '8e28bb91696e2a18b91e8da9687563af';
const BASE_URL = 'https://api.themoviedb.org/3';
const IMAGE_BASE_URL = 'https://image.tmdb.org/t/p/w500';


const TestTMDB = () => {
  const [type, setType] = useState(null);
  const [query, setQuery] = useState('');
  const [yearFrom, setYearFrom] = useState('');
  const [yearTo, setYearTo] = useState('');
  const [results, setResults] = useState([]);
  const [error, setError] = useState('');
  const [actorQuery, setActorQuery] = useState('');


  const handleSearch = async () => {
    if (!type || !query.trim()) return;

    setError('');
    setResults([]);

    try {
      const url = `${BASE_URL}/search/${type}?api_key=${API_KEY}&query=${encodeURIComponent(query)}`;
      const response = await fetch(url);
      const data = await response.json();

      if (!data.results || data.results.length === 0) {
        setError('No results found.');
        return;
      }

      let filteredResults = [];

      for (const item of data.results) {

        if (actorQuery.trim()) {
          const creditsUrl = `${BASE_URL}/${type}/${item.id}/credits?api_key=${API_KEY}`;
          const creditsResponse = await fetch(creditsUrl);
          const creditsData = await creditsResponse.json();

          const actors = creditsData.cast.map(actor => actor.name.toLowerCase());
          const actorNames = actorQuery.toLowerCase().split(',').map(name => name.trim());
          console.log(actorNames)
          console.log(actors)

          const hasSomeActors = actorNames.some(name => actors.includes(name));
          if (!hasSomeActors) continue;
        }

        filteredResults.push(item);
      }

      if (filteredResults.length === 0) {
        setError('No results match all criteria.');
        return;
      }

      filteredResults.sort((a, b) => (b.popularity || 0) - (a.popularity || 0));
      setResults(filteredResults);
    } catch (err) {
      console.error(err);
      setError('Error loading data.');
    }
  };

  const handleTypeMovie = (e) => {
    setType(e.target.dataset.types);
  }


  const copyLink = async () => {
    try {
      const currentUrl = window.location.href;

      if (!navigator.clipboard) {
        throw new Error("Clipboard API не підтримується вашим браузером.");
      }

      await navigator.clipboard.writeText(currentUrl);
      alert("Посилання скопійовано!");
    } catch (err) {
      alert("Помилка копіювання: " + err.message);
    }
  };


  return (
    <div style={{padding: '20px', background: '#fff'}}>
      <div>
        <button data-types='tv' onClick={handleTypeMovie}>Serial</button>
        <button data-types='movie' onClick={handleTypeMovie}>Movie</button>
      </div>

      <input
        type="text"
        placeholder="Movie name"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        style={{margin: '10px 10px 10px 0', padding: '5px', width: '200px'}}
      />

      <input
        type="text"
        placeholder="Actor name"
        value={actorQuery}
        onChange={(e) => setActorQuery(e.target.value)}
        style={{marginRight: '10px', padding: '5px', width: '200px'}}
      />

      <button onClick={handleSearch}>Search</button>

      <div id="results" style={{marginTop: '20px'}}>
        {error && <p>{error}</p>}

        {results.map((item) => {
          const title = item.title || item.name;
          const rating = item.popularity;
          const posterUrl = item.poster_path ? `${IMAGE_BASE_URL}${item.poster_path}` : null;
          const year = (item.release_date || item.first_air_date || '').slice(0, 4);

          return (
            <div key={item.id} style={{marginBottom: '20px'}}>
              <h3>{title} ({year})</h3>
              <p><strong>Rating:</strong> {rating}</p>
              {posterUrl ? (
                <img src={posterUrl} alt={title} width="200"/>
              ) : (
                <p>Poster is not found</p>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TestTMDB;
